
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { WhatsAppButton } from "./components/WhatsAppButton";
import Home from "./pages/Index"; // Changed from "Home" to "Index" as that's the actual file name
import About from "./pages/About";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import BookAppointment from "./pages/BookAppointment";
import DentalAppointmentBooking from "./pages/DentalAppointmentBooking";
import AppointmentBooking from "./pages/AppointmentBooking";
import AppointmentRequest from "./pages/AppointmentRequest";
import AppointmentThankYou from "./pages/AppointmentThankYou";
import Clinics from "./pages/Clinics";
import Blog from "./pages/Blog";
import { BlogPost } from "./components/BlogPost";
import Sitemap from "./pages/Sitemap";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import DentalAds from "./pages/DentalAds";

// Service Pages
import PainlessRCT from "./pages/services/PainlessRCT";
import WisdomToothRemoval from "./pages/services/WisdomToothRemoval";
import LaserDentistry from "./pages/services/LaserDentistry";
import Invisalign from "./pages/services/Invisalign";
import Orthodontics from "./pages/services/Orthodontics";
import GumCleaning from "./pages/services/GumCleaning";
import SingleDayRCT from "./pages/services/SingleDayRCT";
import SmileMakeover from "./pages/services/SmileMakeover";
import ToothWhitening from "./pages/services/ToothWhitening";
import TeethCleaning from "./pages/services/TeethCleaning";
import TMJTMD from "./pages/services/TMJTMD";
import PediatricDentistry from "./pages/services/PediatricDentistry";
import DentalImplants from "./pages/services/DentalImplants";
import CrownsBridges from "./pages/services/CrownsBridges";
import DentalVeneers from "./pages/services/DentalVeneers";
import FullMouthImplants from "./pages/services/FullMouthImplants";
import GeneralDentistry from "./pages/services/GeneralDentistry";
import CosmeticDentistry from "./pages/services/CosmeticDentistry";

function App() {
  return (
    <Router>
        <WhatsAppButton phoneNumber="+918010224989" />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/book-appointment" element={<Navigate to="/dental-appointment-booking" replace />} />
          <Route path="/dental-appointment-booking" element={<DentalAppointmentBooking />} />
          <Route path="/appointment-booking" element={<Navigate to="/dental-appointment-booking" replace />} />
          <Route path="/appointment-request" element={<Navigate to="/dental-appointment-booking" replace />} />
          <Route path="/appointment-thank-you" element={<AppointmentThankYou />} />
          <Route path="/thank-you" element={<AppointmentThankYou />} />
          <Route path="/clinics" element={<Clinics />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/best-dentist-in-sadar-nagpur" element={<Navigate to="/" replace />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/dental-ads" element={<DentalAds />} />
          
          {/* Service Routes */}
          <Route path="/services/painless-rct-in-nagpur" element={<PainlessRCT />} />
          <Route path="/services/wisdom-tooth-removal-in-nagpur" element={<WisdomToothRemoval />} />
          <Route path="/services/laser-dentistry-in-nagpur" element={<LaserDentistry />} />
          <Route path="/services/invisalign-in-nagpur" element={<Invisalign />} />
          <Route path="/services/orthodontics-in-nagpur" element={<Orthodontics />} />
          <Route path="/services/gum-cleaning-in-nagpur" element={<GumCleaning />} />
          <Route path="/services/single-day-rct-in-nagpur" element={<SingleDayRCT />} />
          <Route path="/services/smile-makeover-in-nagpur" element={<SmileMakeover />} />
          <Route path="/services/tooth-whitening-in-nagpur" element={<ToothWhitening />} />
          <Route path="/services/teeth-cleaning-in-nagpur" element={<TeethCleaning />} />
          <Route path="/services/tmj-tmd-in-nagpur" element={<TMJTMD />} />
          <Route path="/services/pediatric-dentistry-in-nagpur" element={<PediatricDentistry />} />
          <Route path="/services/dental-implants-in-nagpur" element={<DentalImplants />} />
          <Route path="/services/crowns-bridges-in-nagpur" element={<CrownsBridges />} />
          <Route path="/services/dental-veneers-in-nagpur" element={<DentalVeneers />} />
          <Route path="/services/full-mouth-implants-in-nagpur" element={<FullMouthImplants />} />
          <Route path="/services/general-dentistry-in-nagpur" element={<GeneralDentistry />} />
          <Route path="/services/cosmetic-dentistry-in-nagpur" element={<CosmeticDentistry />} />
        </Routes>
    </Router>
  );
}

export default App;
